import { QueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { api } from '_api/base';
import { ApiResponseError } from '_api/types';
import { AxiosRequestConfig } from 'axios';

function makeApiCall<T>(
  getEndpoint: () => string,
  requestOptions: AxiosRequestConfig,
): () => Promise<T> {
  return () => api.get(getEndpoint(), requestOptions);
}

const useGetQuery = <T>(
  getEndpoint: () => string,
  requestOptions: AxiosRequestConfig,
  queryKey: QueryKey,
  queryOptions: Omit<UseQueryOptions<T, ApiResponseError>, 'queryKey' | 'queryFn'>,
) =>
  useQuery<T, ApiResponseError>({
    queryKey,
    queryFn: makeApiCall(getEndpoint, requestOptions),
    ...queryOptions,
  });

export default useGetQuery;
